import React, { Component } from 'react';

class Button extends Component {
  goMyzone () {
    window.open('//w3.sbs.co.kr/myzone/myzoneEventLog.do');
  }

  render () {
    return (
      <div className='re_button_w'>
        <button className='re_button_text' onClick={this.goMyzone}>
          참여내역 확인하기
        </button>
      </div>
    );
  }
}

export default Button;
